// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lt-station-roster {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  min-height: 0;
  color: inherit;
}

.lt-station-roster__head {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.lt-station-roster__title {
  margin: 0;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--lt-brand, #0877bc);
}

.lt-station-roster__hint,
.lt-station-roster__empty {
  margin: 0;
  font-size: 0.78rem;
  line-height: 1.35;
  font-weight: 550;
  opacity: 0.78;
}

.lt-station-roster__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-height: 0;
  overflow: auto;
}

.lt-station-roster__row {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 10px;
  align-items: baseline;
  padding: 8px 10px;
  border-radius: 12px;
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 12%, transparent);
  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 28%, transparent);
}

.lt-station-roster__table {
  font-size: 0.78rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.lt-station-roster__players {
  min-width: 0;
  font-size: 0.86rem;
  font-weight: 650;
  line-height: 1.3;
}

.lt-station-roster__players--empty {
  font-weight: 550;
  opacity: 0.62;
}

.lt-pv--station-landscape .lt-station-roster__list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-content: start;
}

.lt-pv__station-panel {
  overflow: auto;
  flex: 1 1 auto;
  max-height: min(58dvh, 480px);
}

.lt-pv--station {
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.lt-pv--station .lt-pv__station-panel {
  max-height: none;
}

.lt-station-roster--settings {
  margin-top: 8px;
}

.lt-pv__station-clocks {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
  font-size: 0.78rem;
  font-weight: 750;
  font-variant-numeric: tabular-nums;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/StationRecordingRoster.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;;EAEE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,yEAAyE;EACzE,+EAA+E;AACjF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC","sourcesContent":[".lt-station-roster {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n  min-height: 0;\n  color: inherit;\n}\n\n.lt-station-roster__head {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.lt-station-roster__title {\n  margin: 0;\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--lt-brand, #0877bc);\n}\n\n.lt-station-roster__hint,\n.lt-station-roster__empty {\n  margin: 0;\n  font-size: 0.78rem;\n  line-height: 1.35;\n  font-weight: 550;\n  opacity: 0.78;\n}\n\n.lt-station-roster__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-height: 0;\n  overflow: auto;\n}\n\n.lt-station-roster__row {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  gap: 10px;\n  align-items: baseline;\n  padding: 8px 10px;\n  border-radius: 12px;\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 12%, transparent);\n  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 28%, transparent);\n}\n\n.lt-station-roster__table {\n  font-size: 0.78rem;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.lt-station-roster__players {\n  min-width: 0;\n  font-size: 0.86rem;\n  font-weight: 650;\n  line-height: 1.3;\n}\n\n.lt-station-roster__players--empty {\n  font-weight: 550;\n  opacity: 0.62;\n}\n\n.lt-pv--station-landscape .lt-station-roster__list {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  align-content: start;\n}\n\n.lt-pv__station-panel {\n  overflow: auto;\n  flex: 1 1 auto;\n  max-height: min(58dvh, 480px);\n}\n\n.lt-pv--station {\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.lt-pv--station .lt-pv__station-panel {\n  max-height: none;\n}\n\n.lt-station-roster--settings {\n  margin-top: 8px;\n}\n\n.lt-pv__station-clocks {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 14px;\n  font-size: 0.78rem;\n  font-weight: 750;\n  font-variant-numeric: tabular-nums;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
